import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Save, RotateCcw, ImagePlus } from "lucide-react";

export const ContentTab = ({ schema, values, setValues, busy, onSave, onReset, onImage }) => (
  <>
    <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
      <h2 className="text-xl font-heading font-medium text-ink">Site Content</h2>
      <div className="flex gap-2">
        <button data-testid="reset-content-btn" onClick={onReset} disabled={busy} className="border border-line rounded-lg px-4 py-2 text-sm hover:bg-bone flex items-center gap-1.5"><RotateCcw className="h-4 w-4" /> Reset defaults</button>
        <button data-testid="save-content-btn" onClick={onSave} disabled={busy} className="bg-forest text-white rounded-lg px-4 py-2 text-sm hover:bg-forest-hover flex items-center gap-1.5 disabled:opacity-60">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save changes</button>
      </div>
    </div>

    <div className="space-y-6">
      {schema.map((group) => (
        <div key={group.group} className="bg-white border border-line rounded-xl p-6">
          <h3 className="font-heading font-medium text-ink mb-4">{group.group}</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {group.fields.map((f) => (
              <div key={f.key} className={f.type === "textarea" || f.type === "image" ? "md:col-span-2" : ""}>
                <Label>{f.label}</Label>
                {f.type === "text" && (
                  <Input data-testid={`content-${f.key}`} value={values[f.key] || ""} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} className="mt-1 border-line" />
                )}
                {f.type === "textarea" && (
                  <Textarea data-testid={`content-${f.key}`} value={values[f.key] || ""} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} className="mt-1 border-line" rows={2} />
                )}
                {f.type === "image" && (
                  <div className="mt-1 flex items-center gap-4">
                    {values[f.key] && <img src={values[f.key]} alt="" className="h-20 w-28 object-cover rounded-lg border border-line" />}
                    <div className="flex-1 space-y-2">
                      <Input data-testid={`content-${f.key}`} value={values[f.key] || ""} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} className="border-line" placeholder="Image URL" />
                      <label className="inline-flex items-center gap-1.5 text-sm text-forest cursor-pointer hover:underline">
                        <ImagePlus className="h-4 w-4" /> Upload image
                        <input data-testid={`content-upload-${f.key}`} type="file" accept="image/*" onChange={onImage(f.key)} className="hidden" />
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </>
);
